export type Tema = "claro" | "escuro";
const CHAVE = "enotes:tema";

export function temaAtual(): Tema {
  const salvo = localStorage.getItem(CHAVE);
  if (salvo === "claro" || salvo === "escuro") return salvo;
  return "escuro";
}
export function aplicarTema(t: Tema): void {
  localStorage.setItem(CHAVE, t);
  document.documentElement.classList.toggle("dark", t === "escuro");
}
export const alternarTema = (): Tema => {
  const proximo: Tema = temaAtual() === "claro" ? "escuro" : "claro";
  aplicarTema(proximo);
  return proximo;
};
